import React, {useMemo} from 'react';
import {Field, useFormikContext} from 'formik';
import {TextField} from 'formik-mui';
import {Autocomplete, Card, TextField as MuiTextField, Typography} from '@mui/material';

export default function CatalogueEntryTwo({code, isEdit, masters}) {
  const {values, setFieldValue, touched, errors} = useFormikContext();

  const selectedDimensions = useMemo(() => {
    const ids = values?.dimension_ids || [];
    const options = masters?.dimensions || [];
    return (options || []).filter(opt => ids.includes(opt?.id));
  }, [masters?.dimensions, values?.dimension_ids]);

  const dimError = touched?.dimension_ids && errors?.dimension_ids ? errors?.dimension_ids : '';

  const dimensionLabel = (dimension) => {
    const items = dimension?.items || [];
    if (!items?.length) return dimension?.name || dimension?.code || '';
    const itemsText = items
      .map(it => `${it?.label || ''}${it?.unit ? ` - ${it.unit}` : ''}`)
      .filter(Boolean)
      .join(', ');
    return `${dimension?.name || dimension?.code || ''}${itemsText ? ` (${itemsText})` : ''}`;
  };

  return (
    <Card className={'box-shadow'} sx={{p: 4}}>
      <Typography variant="subtitle1" sx={{mt: 2, mb: 1, fontSize: 14, color: '#929191'}}>
        Dimensions
      </Typography>
      <Field
        component={TextField}
        variant={'outlined'}
        size={'small'}
        fullWidth
        label={'Length (cm)'}
        name={'dimension_values.length'}
        placeholder="Enter length in cm"
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true,
        }}
      />
      <Field
        component={TextField}
        variant={'outlined'}
        size={'small'}
        fullWidth
        label={'Width/Circumtance (cm)'}
        name={'dimension_values.width'}
        placeholder="Enter width in cm"
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true,
        }}
      />
      <Field
        component={TextField}
        variant={'outlined'}
        size={'small'}
        fullWidth
        label={'Height (cm)'}
        name={'dimension_values.height'}
        placeholder="Enter height in cm"
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true,
        }}
      />
      <Field
        component={TextField}
        variant={'outlined'}
        size={'small'}
        fullWidth
        label={'Weight (kg)'}
        name={'dimension_values.weight'}
        placeholder="Enter weight in kg"
        sx={{mt: 1.5}}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true,
        }}
      />
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
             label={'Dyes'}
             name={`translations.${code}.dyes`} sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'}
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
             label={'Motifs'}
             name={`translations.${code}.motifs`} sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'}
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
             label={'Date of Acquisition'} type={'date'}
             name={'date_of_aquisition'} sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
             label={'Description'} multiline rows={4}
             name={`translations.${code}.description`} sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
             }}/>
    </Card>
  );
}